import React, { useRef, useState, useEffect } from "react";
import "./style.css";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Home = ({ socket }) => {
  const inputRef = useRef();
  const inputRef2 = useRef();
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);

  const tooglePopup = (x = null) => {
    if (x == null) {
      setPopup(!popup);
    } else {
      setPopup(x);
    }
  };

  const saveName = () => {
    localStorage.setItem("name", inputRef2.current.value);
    tooglePopup(false);
  };

  const getName = () => {
    var name = localStorage.getItem("name");
    return name ?? "Player" + Math.floor(Math.random() * 100);
  };

  const createRoom = () => {
    socket.emit("createRoom", getName());
  };

  const joinRoom = () => {
    socket.emit("checkRoom", inputRef.current.value);
  };

  const showError = (msg) => {
    toast.error(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  };

  useEffect(() => {
    socket.on("roomCreated", (roomId) => {
      navigate(`/room/${roomId}`);
    });

    socket.on("validRoom", (roomId) => {
      navigate(`/room/${roomId}`);
    });

    socket.on("invalidRoom", () => {
      showError("Invalid Room ID");
    });
    socket.on("roomFull", () => {
      showError("Room is Full");
    });

    return () => {
      socket.off();
    };
  }, []); // eslint-disable-line

  return (
    <div className="home">
      <div className="logo">
        <img src="logo.png" alt="Logo" />
        <span className="text">WebTacToe</span>
      </div>
      <div className="actions">
        <div className="btn" onClick={createRoom}>
          <i>C</i>
          <i>r</i>
          <i>e</i>
          <i>a</i>
          <i>t</i>
          <i>e</i>
          <i>&nbsp;</i>
          <i>R</i>
          <i>o</i>
          <i>o</i>
          <i>m</i>
        </div>
        <div className="join-btn">
          <input type="text" placeholder="Enter Room ID" ref={inputRef} />
          <div className="btn" onClick={joinRoom}>
            <i>J</i>
            <i>o</i>
            <i>i</i>
            <i>n</i>
            <i>&nbsp;</i>
            <i>R</i>
            <i>o</i>
            <i>o</i>
            <i>m</i>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="profile" onClick={() => tooglePopup()}>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_iconCarrier">
              <path
                d="M22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12C2 14.9 3.25 17.51 5.23 19.34C5.23 19.35 5.23 19.35 5.22 19.36C5.32 19.46 5.44 19.54 5.54 19.63C5.6 19.68 5.65 19.73 5.71 19.77C5.89 19.92 6.09 20.06 6.28 20.2C6.35 20.25 6.41 20.29 6.48 20.34C6.67 20.47 6.87 20.59 7.08 20.7C7.15 20.74 7.23 20.79 7.3 20.83C7.5 20.94 7.71 21.04 7.93 21.13C8.01 21.17 8.09 21.21 8.17 21.24C8.39 21.33 8.61 21.41 8.83 21.48C8.91 21.51 8.99 21.54 9.07 21.56C9.31 21.63 9.55 21.69 9.79 21.75C9.86 21.77 9.93 21.79 10.01 21.8C10.29 21.86 10.57 21.9 10.86 21.93C10.9 21.93 10.94 21.94 10.98 21.95C11.32 21.98 11.66 22 12 22C12.34 22 12.68 21.98 13.01 21.95C13.05 21.95 13.09 21.94 13.13 21.93C13.42 21.9 13.7 21.86 13.98 21.8C14.05 21.79 14.12 21.76 14.2 21.75C14.44 21.69 14.69 21.64 14.92 21.56C15 21.53 15.08 21.5 15.16 21.48C15.38 21.4 15.61 21.33 15.82 21.24C15.9 21.21 15.98 21.17 16.06 21.13C16.27 21.04 16.48 20.94 16.69 20.83C16.77 20.79 16.84 20.74 16.91 20.7C17.11 20.58 17.31 20.47 17.51 20.34C17.58 20.3 17.64 20.25 17.71 20.2C17.91 20.06 18.1 19.92 18.28 19.77C18.34 19.72 18.39 19.67 18.45 19.63C18.56 19.54 18.67 19.45 18.77 19.36C18.77 19.35 18.77 19.35 18.76 19.34C20.75 17.51 22 14.9 22 12ZM16.94 16.97C14.23 15.15 9.79 15.15 7.06 16.97C6.62 17.26 6.26 17.6 5.96 17.97C4.44 16.43 3.5 14.32 3.5 12C3.5 7.31 7.31 3.5 12 3.5C16.69 3.5 20.5 7.31 20.5 12C20.5 14.32 19.56 16.43 18.04 17.97C17.75 17.6 17.38 17.26 16.94 16.97Z"
                fill="#FFF"
              ></path>
              <path
                d="M12 6.92969C9.93 6.92969 8.25 8.60969 8.25 10.6797C8.25 12.7097 9.84 14.3597 11.95 14.4197C11.98 14.4197 12.02 14.4197 12.04 14.4197C12.06 14.4197 12.09 14.4197 12.11 14.4197C12.12 14.4197 12.13 14.4197 12.13 14.4197C14.15 14.3497 15.74 12.7097 15.75 10.6797C15.75 8.60969 14.07 6.92969 12 6.92969Z"
                fill="#FFF"
              ></path>
            </g>
          </svg>
        </div>
        <div className={`popup ${popup ? "" : " hidden"}`}>
          <div className="header">
            <i></i>
            <span>Edit Profile</span>
            <span className="close" onClick={() => tooglePopup(false)}>
              <svg
                fill="#000000"
                width="30px"
                height="30px"
                viewBox="0 0 32 32"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_iconCarrier">
                  <path d="M18.8,16l5.5-5.5c0.8-0.8,0.8-2,0-2.8l0,0C24,7.3,23.5,7,23,7c-0.5,0-1,0.2-1.4,0.6L16,13.2l-5.5-5.5 c-0.8-0.8-2.1-0.8-2.8,0C7.3,8,7,8.5,7,9.1s0.2,1,0.6,1.4l5.5,5.5l-5.5,5.5C7.3,21.9,7,22.4,7,23c0,0.5,0.2,1,0.6,1.4 C8,24.8,8.5,25,9,25c0.5,0,1-0.2,1.4-0.6l5.5-5.5l5.5,5.5c0.8,0.8,2.1,0.8,2.8,0c0.8-0.8,0.8-2.1,0-2.8L18.8,16z"></path>{" "}
                </g>
              </svg>
            </span>
          </div>
          <div className="body">
            <span>Player Name</span>
            <input
              type="text"
              placeholder="Enter Player Name"
              defaultValue={getName()}
              ref={inputRef2}
            />
          </div>
          <div className="button">
            <button onClick={saveName}>Save & Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
